import { render, staticRenderFns } from "./EmployeeAttendance.vue?vue&type=template&id=228b8203"
import script from "./EmployeeAttendance.vue?vue&type=script&lang=js"
export * from "./EmployeeAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports